import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        planningGroup: '='
    },
    template: `
        <loader-icon ng-if="vm.saving" overlay="true"></loader-icon>
        <div class="wrapper" ng-hide="vm.saving">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
                    <h2 class="modal-title">{{ 'general.Confirm' | translate }}</h2>
                </div>
                <div class="modal-body">
                    <div class="alert alert-warn">
                        <span ng-if="!vm.cancel" ng-bind-html="vm.stopGroupConfirmMessage"></span>
                        <span ng-if="vm.cancel" ng-bind-html="vm.cancelGroupConfirmMessage"></span>
                    </div>
                    <form-wrapper>
                        <form-row error="vm.form.errors.status">
                            <form-row-error></form-row-error>
                        </form-row>
                        <ul class="checkboxes">
                            <li>
                                <label><input
                                    type="checkbox"
                                    ng-model="vm.cancel"
                                > {{ 'planningGroup.Cancel automated planning group' | translate }}</label>
                            </li>
                        </ul>
                    </form-wrapper>
                </div>
                <div class="modal-footer">
                    <ul class="actions01">
                        <li class="primary">
                            <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Yes' | translate }}</button>
                        </li>
                        <li>
                            <button class="btn discrete" autofocus type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.No' | translate }}</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, AutomatedPlanningGroupResource, FormFactory, AUTOMATED_PLANNING_GROUP_STATUS_ENUM) {
        this.$translate = $translate;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.form = FormFactory.createFromResource(
            this.planningGroup,
            { expand: 'planningGroupUsers,course,planningGroupTargetsWithValue.user.drlsWithValue,planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue,targetRulesets.conditions' }
        );
    }

    $onInit () {
        this.stopGroupConfirmMessage = this.$translate.instant('planningGroup.stop_group_confirm_message');
        this.cancelGroupConfirmMessage = this.$translate.instant('planningGroup.cancel_group_confirm_message');
    }

    save () {
        this.saving = true;
        this.form.model.status = this.cancel ?
            this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.CANCELLED :
            this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STOPPED
        ;
        this.form.save()
            .then(model => {
                this.saving = false;
                this.uibModalInstance.close(model);
            })
            .catch(() => {
                this.saving = false;
            })
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/automated/planningGroup/status/index.js